import styled from '@emotion/styled';

interface TabStickyProps {
	isNotSticky: boolean;
}
export const TabListContainer = styled.div<TabStickyProps>`
	position: ${({ isNotSticky }) => (isNotSticky ? '' : 'sticky')};
	top: ${(props) => props.theme.heights.header};
	z-index: 9;
	display: flex;
	height: 5.2rem;
	background: white; // 배경색 추가해서 투명 배경 문제 방지
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	overflow: auto;
	scrollbar-width: none;
	@media screen and (max-width: 1180px) {
		top: ${(props) => props.theme.heights.headerMobile};
	}
`;
export const TabListItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	min-width: 16.88rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	border-right: 1px solid #dee2e6;
	background-color: #f1f3f5;
	cursor: pointer;
	white-space: nowrap;

	:last-child {
		border-right: none;
	}
	&.active {
		color: #ffff;
		background-color: ${(props) => props.theme.colors.primary400};
	}
`;
